import { reactive, ref } from 'vue'
import { isMobileDevice, getTextWidth, Base64 } from '@/utils/util'
import { handleArticleStr } from '@/utils/domUtils'
import useVideo from './useVideo'
import useAudio from './useAudio'
import useImage from './useImage'
import useSwiper from './useSwiper'
import useSwiperPoster from './useSwiperPoster'
import { useEchart } from './useEchart'

export default function (type: 'mobile' | 'pc') {
  const objectType = document.body.getAttribute('data-objectType')
  const content = document.getElementById('newContent')?.innerHTML

  const { start: startAudio, audioPlayNum } = useAudio()
  const { addSwiper, startSwiper } = useSwiper(type)
  const { initImage, remove: removeImage } = useImage()
  const { addSwiperPoster, startSwiperPoster } = useSwiperPoster(type)
  const { addVideoList, initVideo } = useVideo(type, audioPlayNum)
  const { start: startEchart } = useEchart(type)

  const imagePreview = ref([])

  const imageState = reactive({
    startPosition: 0,
    showImagePreview: false
  })

  const startSwiperText = () => {
    const basicWidth = getTextWidth(
      'Trucks wait to load containers at a container terminal in Rizhao。',
      {
        fontSize: isMobileDevice() ? '0.32rem' : '16px',
        whiteSpace: 'nowrap',
        fontFamily: 'DroidSerif',
        paddingLeft: isMobileDevice() ? '1.06666667rem' : '44px'
      }
    )
    const swiperText = document.querySelectorAll('#newContent .en-scroll-text .swiper-txet')
    for (let i = 0; i < swiperText.length; i++) {
      const leftElement = swiperText[i].parentNode?.querySelector('.scroll-text-left')
      const newsTitleElement = document.querySelector('#newsTitle')
      if (!leftElement || !newsTitleElement) continue
      const leftWidth = leftElement.getBoundingClientRect().width
      const allWidth = newsTitleElement.getBoundingClientRect().width - leftWidth
      const width = swiperText[i].getBoundingClientRect().width
      const keyframes = document.createElement('style')
      document.head.appendChild(keyframes)
      const keyframesSheet = keyframes.sheet
      const rate = 10 / (allWidth + basicWidth)
      const firstDuration = rate * width

      // 定义关键帧的样式
      const frameStyles = `0% {transform: translateX(0%);}100% {transform: translateX(calc(${-width}px + 44px));}`
      const frameStyless = `0% {transform: translateX(calc(${allWidth}px - 12px));}100% {transform: translateX(calc(${-width}px + 44px));}`

      // 添加关键帧到样式表中
      keyframesSheet.insertRule(`@keyframes swiperText${i} { ${frameStyles} }`, 0)
      keyframesSheet.insertRule(`@keyframes swiperTextIn${i} { ${frameStyless} }`, 1)
      // @ts-ignore
      swiperText[i].style.animation = `swiperText${i} ${firstDuration}s linear`
      // @ts-ignore
      swiperText[i].style.animationDelay = `.5s`
      setTimeout(() => {
        // @ts-ignore
        swiperText[i].style.animation = `swiperTextIn${i} ${
          rate * (allWidth + width)
        }s linear infinite`
        // @ts-ignore
        swiperText[i].style.animationDelay = `0`
      }, firstDuration * 1000 + 500)
    }
  }

  const addLinkClick = () => {
    const aEl = document.querySelectorAll('#newContent a')
    for (let i = 0; i < aEl.length; i++) {
      const peopleOrigin = [
        'peoplesdaily.pdnews.cn',
        'overseas.pdnews.cn',
        'pd-eos-sit.pdnews.cn',
        'pd-eos-uat.pdnews.cn'
      ]
      let url = aEl[i].getAttribute('data-href') || aEl[i].getAttribute('href') || ''
      if (peopleOrigin.some((origin) => url.includes(origin))) {
        if (!url.includes('isIner=0') && location.href.includes('isIner=0')) {
          if (url.includes('?')) {
            if (url[url.length - 1] !== '?') {
              url = `${url}&isIner=0`
            } else if (url[url.length - 1] === '?') {
              url = `${url}isIner=0`
            }
          } else {
            url = `${url}?isIner=0`
          }
        }
      }

      let dataInfo = aEl[i].getAttribute('data-rmrbnative')
      try {
        if (dataInfo) {
          dataInfo = Base64().decode(dataInfo)
          dataInfo = JSON.parse(dataInfo)
        }
      } catch (error) {}

      // linkType: 不跳转 2: 内部跳转 3: 外部跳转

      aEl[i].setAttribute('href', dataInfo?.linkType == 1 ? 'javascript:;' : url)
      if (dataInfo?.linkType == 1) {
        aEl[i].target = ''
      }
    }
  }

  const handleArticleContent = (contentText?: string) => {
    setTimeout(() => {
      handleArticleStr(
        content || contentText || '',
        (type, option) => {
          if (type === 1) {
          } else if (type === 2) {
            addVideoList(option)
          } else if (type === 3) {
            addSwiper(option)
          } else if (type === 4) {
            addSwiperPoster(option)
          }
        },
        type
      )
      startSwiperText()

      initVideo()
      addLinkClick()
      initImage()
      startAudio()
      startEchart()
      startSwiper()
      startSwiperPoster()
    }, 500)
  }

  const initEditorStr = (contentText?: string) => {
    const textStr = content || contentText || ''
    if (!textStr) {
      if (document.querySelector('.skeleton-loading')) {
        document.querySelector('.skeleton-loading').classList.add('none')
      }
      const newContentEl = document.getElementById('newContent')
      if (newContentEl) {
        newContentEl.setAttribute('class', type === 'pc' ? 'c-news-content' : 'news-content')
      }
      return
    }
    if (objectType == '8' || objectType == '13') handleArticleContent(contentText)
  }

  const resetPage = () => {
    removeImage()
  }

  return {
    imageState,
    imagePreview,
    initEditorStr,
    resetPage
  }
}
